module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return (_vm.showIt) ? _c('div', {
    class: {
      'weui-skin_android': _vm.android
    }
  }, [_c('div', {
    staticClass: "weui-mask",
    staticStyle: {
      "opacity": "1"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "popup"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui-dialog"
  }, [_c('div', {
    staticClass: "weui-dialog__hd"
  }, [_c('strong', {
    staticClass: "weui-dialog__title"
  }, [_vm._v(_vm._s(_vm.dialogObj.title))])]), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__bd",
    domProps: {
      "innerHTML": _vm._s(_vm.dialogObj.content)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__ft"
  }, [(_vm.dialogObj.assistBtn) ? _c('a', {
    staticClass: "weui-dialog__btn weui-dialog__btn_default",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.cbFn(_vm.dialogObj.assistFn)
      }
    }
  }, [_vm._v(_vm._s(_vm.dialogObj.assistBtn))]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "weui-dialog__btn weui-dialog__btn_primary",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.cbFn(_vm.dialogObj.mainFn)
      }
    }
  }, [_vm._v(_vm._s(_vm.dialogObj.mainBtn))])])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-bc107180!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/dialog.vue
// module id = 282
// module chunks = 0